export default "__VITE_ASSET__SvLYxunu__"